import {Controller, useFormContext} from "react-hook-form";
import {Input} from "antd";
import {
  StyledDiscountFormContainer,
  StyledDiscountFormItem,
} from "../styles/discount-form.styles";
import {DiscountCodeVariationFormFieldV2} from "../variation-form-field-v2";

export function CodeNameFormFieldV2() {
  const {control} = useFormContext();
  return (
    <StyledDiscountFormContainer>
      <div className="form-header">General information</div>
      <div className="form-content">
        <StyledDiscountFormItem>
          <div className="label-row">
            <label>Code name</label>
          </div>
          <Controller
            control={control}
            name="name"
            render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
              <>
                <Input
                  status={error?.message ? "error" : ""}
                  onChange={onChange}
                  onBlur={onBlur}
                  size="large"
                  value={value}
                  placeholder="e.g Summer2026"
                  ref={ref}
                />
                {error && (
                  <div role="alert" className="ant-form-item-explain-error">
                    {error.message}
                  </div>
                )}
              </>
            )}
          />
        </StyledDiscountFormItem>
        <DiscountCodeVariationFormFieldV2 />
      </div>
    </StyledDiscountFormContainer>
  );
}
